export default __webpack_public_path__ + "static/media/FR.a8f2e2f1.svg";